import { StatusBadge } from '@/components/common/StatusBadge';

const ACTIVE_STATUS_LABELS = {
  active: 'Active',
  inactive: 'Inactive',
} as const;

interface ActiveStatusBadgeProps {
  isActive: boolean;
}

export function ActiveStatusBadge({ isActive }: ActiveStatusBadgeProps) {
  if (isActive) return <StatusBadge tone="success">{ACTIVE_STATUS_LABELS.active}</StatusBadge>;
  return <StatusBadge tone="danger">{ACTIVE_STATUS_LABELS.inactive}</StatusBadge>;
}
